// Thứ tự theo bản mẫu Quality Monitoring BM; nhãn đổi sang tiếng Việt theo yêu cầu (lệch mockup, đã xác nhận).
// hint = mô tả ngắn hiện khi hover tab
export const TABS = [
    {key: 'report', label: 'Tổng quan', hint: 'Tổng quan nhóm lỗi toàn nhà máy, theo ngày phát hiện lỗi'},
    {key: 'process', label: 'Theo công đoạn', unit: 'Nhóm lỗi', hint: 'Tổng quan theo công đoạn sản xuất, theo ngày phát hiện lỗi'},
    {key: 'material', label: 'Nguyên vật liệu', unit: 'Nhà cung cấp', group: 'fabric', hint: 'Tỉ lệ lỗi theo nhà cung cấp vải, theo ngày nhận vải'},
    {key: 'print', label: 'In', unit: 'Máy in', group: 'print', hint: 'Tỉ lệ lỗi theo máy in, theo ngày in'},
    {key: 'press', label: 'Ép', unit: 'Máy ép', group: 'press', hint: 'Tỉ lệ lỗi theo máy ép, theo ngày chuyển ép'},
    {key: 'sewing', label: 'May', unit: 'Tổ may', group: 'sewing', hint: 'Tỉ lệ lỗi theo tổ may, theo ngày giao may'},
    {key: 'cut', label: 'Cắt', unit: 'Thợ cắt', group: 'cut', hint: 'Tỉ lệ lỗi theo thợ cắt, theo ngày cắt'},
]

export const GROUP_ORDER = ['fabric', 'print', 'press', 'sewing', 'cut', 'billet', 'other', 'unknown']

export const GROUP_LABELS = {
    fabric: 'Lỗi vải',
    print: 'Lỗi in',
    press: 'Lỗi ép',
    sewing: 'Lỗi may',
    cut: 'Lỗi cắt',
    billet: 'Lỗi phôi',
    other: 'Khác',
    unknown: 'Không xác định',
}

// Nhóm có màu cố định, không theo vị trí; còn lại dùng SERIES_COLORS
export const GROUP_COLORS = {unknown: '--s-na'}

// Biểu đồ tròn cơ cấu lỗi: số lát riêng tối đa, phần còn lại gộp một lát màu trung tính.
// Không dùng chữ "Khác" (trùng nhóm lỗi Khác) như OTHER_KEY của biểu đồ ngày
export const PIE_TOP = 4
export const PIE_REST = {key: '__rest', label: 'Còn lại', color: '--s-rest'}

export const SERIES_COLORS = ['--s1', '--s2', '--s3', '--s4', '--s7', '--s5', '--s6', '--s8', '--s2', '--s3', '--s4', '--s1', '--s5', '--s7', '--s6', '--s8', '--s1']

export const STAGES = [
    {value: '', label: 'Tất cả công đoạn'},
    {value: 'fabric', label: 'Nguyên vật liệu'},
    {value: 'print', label: 'Công đoạn In'},
    {value: 'press', label: 'Công đoạn Ép'},
    {value: 'sewing', label: 'Công đoạn May'},
    {value: 'cut', label: 'Công đoạn Cắt laser'},
]

export const PRESETS = [
    {value: '30', label: '30 ngày'},
    {value: '90', label: '90 ngày'},
    {value: 'm', label: 'Tháng này'},
    {value: 'cus', label: 'Tùy chọn'},
]

export const MAX_DAILY_DAYS = 92
export const MAX_RANGE_DAYS = 366
export const DAILY_TOP_DIMS = 8
export const OTHER_KEY = 'Khác (gộp)'
// Giá trị <select> của dòng "Chưa gán" (dim_id rỗng), tránh trùng value="" với option "Tất cả"
export const UNASSIGNED_OBJ = '__unassigned__'
